// Models
import { FormFieldArraySchema, FormFieldSchema } from 'app/shared/models/form';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

// Utils
import { required } from 'app/shared/utils/validation';

// Constants
import { TRANSMODE_CODE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/transactionMode';

export const TXN_TRANSACTION_NUMBER_FIELD: FormFieldSchema<string> = {
  label: 'Transaction number',
  name: 'transactionnumber',
  required: true,
  type: U21FormFieldTypes.TEXT,
  validate: required('Transaction number is required.'),
};

export const TXN_INTERNAL_REF_NUMBER_FIELD: FormFieldSchema<string> = {
  label: 'Internal reference number',
  name: 'internal_ref_number',
  type: U21FormFieldTypes.TEXT,
};

export const TXN_LOCATION_FIELD: FormFieldSchema<string> = {
  label: 'Transaction location',
  name: 'transaction_location',
  required: true,
  type: U21FormFieldTypes.TEXT,
  validate: required('Transaction location is required.'),
};

export const TXN_DESCRIPTION_FIELD: FormFieldSchema<string> = {
  label: 'Transaction description',
  name: 'transaction_description',
  required: true,
  type: U21FormFieldTypes.TEXTAREA,
  validate: required('Transaction description is required.'),
};

export const TXN_DATE_FIELD: FormFieldSchema<string> = {
  label: 'Transaction date',
  name: 'date_transaction',
  type: U21FormFieldTypes.DATE_PICKER,
  required: true,
  validate: required('Transaction date is required.'),
};

export const TXN_TELLER_FIELD: FormFieldSchema<string> = {
  label: 'Teller',
  name: 'teller',
  type: U21FormFieldTypes.TEXT,
};

export const TXN_AUTHORIZED_FIELD: FormFieldSchema<string> = {
  label: 'Authorized by',
  name: 'authorized',
  type: U21FormFieldTypes.TEXT,
};

export const TXN_LATE_DEPOSIT_FIELD: FormFieldSchema<string> = {
  label: 'Late deposit',
  name: 'late_deposit',
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    options: [
      { value: '0', text: 'No' },
      { value: '1', text: 'Yes' },
    ],
  },
};

export const TXN_DATE_POSTING_FIELD: FormFieldSchema<string> = {
  label: 'Date of posting',
  name: 'date_posting',
  type: U21FormFieldTypes.DATE_PICKER,
};

export const TXN_VALUE_DATE_FIELD: FormFieldSchema<string> = {
  label: 'Value date',
  name: 'value_date',
  type: U21FormFieldTypes.DATE_PICKER,
};

export const TXN_MODE_CODE_FIELD: FormFieldSchema<string> = {
  label: 'Transaction mode',
  name: 'transmode_code',
  type: U21FormFieldTypes.SELECT,
  required: true,
  validate: required('Transaction mode is required.'),
  fieldProps: {
    options: TRANSMODE_CODE_OPTIONS,
  },
  default: TRANSMODE_CODE_OPTIONS[0].value,
};

export const TXN_MODE_COMMENT_FIELD: FormFieldSchema<string> = {
  label: 'Transaction mode comment',
  name: 'transmode_comment',
  type: U21FormFieldTypes.TEXT,
};

export const TXN_AMOUNT_FIELD: FormFieldSchema<string> = {
  label: 'Local amount',
  name: 'amount_local',
  type: U21FormFieldTypes.TEXT,
  required: true,
};

export const TXN_COMMENTS: FormFieldSchema<string> = {
  label: 'Comments',
  name: 'comments',
  type: U21FormFieldTypes.TEXTAREA,
  required: true,
};

// TODO add goods_services
// TODO add involved_parties

export const TRANSACTION_RAW_INPUTS = [
  TXN_TRANSACTION_NUMBER_FIELD,
  TXN_INTERNAL_REF_NUMBER_FIELD,
  TXN_LOCATION_FIELD,
  TXN_DATE_FIELD,
  TXN_TELLER_FIELD,
  TXN_AUTHORIZED_FIELD,
  TXN_MODE_CODE_FIELD,
  TXN_MODE_COMMENT_FIELD,
  TXN_AMOUNT_FIELD,
  TXN_DESCRIPTION_FIELD,

  // TODO support the different combinations, disabling for now to avoid confusion
  // 1. none of the nodes are set
  // 2. only late_deposit is set
  // 3. late_deposit AND date_posting are set
  // TXN_LATE_DEPOSIT_FIELD,
  // TXN_DATE_POSTING_FIELD,

  TXN_VALUE_DATE_FIELD,
];

export const TRANSACTIONS_FIELD: FormFieldArraySchema<any> = {
  default: [],
  name: 'content.report.transaction',
  label: 'Transactions',
  fields: [
    ...TRANSACTION_RAW_INPUTS,
    // No need to add From/To combinations here, getInitialValues copies the whole object
  ],
  type: 'ARRAY',
};
